import * as React from 'react';

import styled from 'styled-components';

import { getFontFamily } from 'services/FontService';
import { Colors } from 'services/ColorService';

export interface IUserInfoProps {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export const UserInfo = ({ firstName, lastName, email }: IUserInfoProps) => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

  if (!fullName && !email) {
    return null;
  }

  return (
    <Wrapper>
      {fullName ? (
        <>
          <Name>{fullName}</Name>
          {email ? <Email>{email}</Email> : null}
        </>
      ) : (
        <Name>{email}</Name>
      )}
    </Wrapper>
  );
};

/**
 * Не шире 200 px, лишнее — многоточием: длинное имя или адрес иначе
 * выдавливали бы меню из шапки на 1280 px. Полностью — в подсказке кнопки
 * профиля, которая оборачивает этот блок (своя подсказка здесь перебивала бы
 * её). `span`, а не `div`: блок стоит внутри `button`.
 */
const Wrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 200px;
  text-align: right;
  line-height: 1.2;
`;

const Name = styled.span`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: ${getFontFamily('bold')};
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${Colors.Black};
`;

const Email = styled.span`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: ${Colors.Gray};
  margin-top: 2px;
`;
